import {Observable}                  from 'rxjs';
import {filter, map, withLatestFrom} from 'rxjs/operators';

import MediaEventType            from '../../../../Solutions/Shared/Constants/MediaEventType';
import IMediaEventsStreamPayload from '../../../../Solutions/Shared/Interfaces/IMediaEventsStreamPayload';
import Playback                  from '../Playback';

const createEndedStream = (
    mediaEvents$: Observable<IMediaEventsStreamPayload>,
    playbackStoreUpdate$: Observable<Playback>
): Observable<void> =>
    mediaEvents$
        .pipe(
            withLatestFrom(playbackStoreUpdate$),
            filter(([{type}, {hasEnded}]) => type === MediaEventType.ENDED && !hasEnded),
            map(() => void 0)
        );

export default createEndedStream;